import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderDetailService } from '../order-detail.service';
import { OrderDetail } from '../order-detail';
import { OrderProductService } from '@app/_components/order-product/order-product.service';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import { BedService } from '@app/_components/property/bed/bed.service';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderDetailComponent implements OnInit {
    orderProducts: any;

	orderProductId: any;
    reservations: any;
	shortTermRentalId: any;
    beds: any;
	orderDetails: any;
	// Its disbale product selection
	isUpdate: boolean;
	password: string | null = null;

	constructor(
		private bedService: BedService,
		private reservationService: ReservationService,
		private orderProductService: OrderProductService,
		private primengConfig: PrimeNGConfig,
		private orderDetailService: OrderDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderDetail = data.orderDetail;
			this.shortTermRentalId = data?.shortTermRentalId;
			this.password = data?.password ?? null;
			console.log("ddddddddddddddd : "+JSON.stringify(this.orderDetail));
		//	this.orderDetails = orderDetailService.orderDetails;
			this.isUpdate = false;
	}

	@Input() orderDetail: OrderDetail;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderDetailId: number;
	property: any = null;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderDetailId': [],
		'orderId': [],
		'orderProductId': [],
		'reservationId': [],
		'bedId': [],
		'quantity': [{ type: 'required', message: 'Required' }],
		'listPrice': [{ type: 'required', message: 'Required' }],
		'listPriceAdjustmentPercent': [],
		'listPriceAdjustmentAmount': [],
		'description': [],
		'privateNotes': [],
		'publicNotes': [],
		'changeLog': [],
		'guestNotes': [],
		'name': [],
		'salesTaxable': [],
		'roomTaxable': [],
	};
	
	ngOnInit() {
		this.fetchOrderProducts();
		this.fetchBeds();
		this.fetchProperty();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole orderDetail object
		if (this.orderDetail) {
			this.orderDetailId = this.orderDetail?.orderDetailId;
			// Its disbale product selection
			this.isUpdate = this.orderDetail?.orderDetailId > 0;
			this.fixDates();
			this.form1.patchValue(this.orderDetail);

		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			if (this.formLoading) { return; }
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			// Step 1: property-level hard block (no rollaway/futon support at this property)
			const bedValidationError = this.validateBedAvailability();
			if (bedValidationError) {
				this.formAlert = bedValidationError;
				return;
			}
			this.formAlert = null;

			// Step 2: pool-level availability warning (admin-only, non-blocking)
			const bedType = this.getSelectedBedType();
			const reservationId = this.form1.value?.reservationId;
			if (bedType && reservationId) {
				this.reservationService.getBedAvailability(reservationId)
					.subscribe(
						(res: any) => {
							const avail = res?.data?.bedAvailability;
							if (avail) {
								if (bedType === 'rollaway' && avail.rollAwayAvailable === 0) {
									this.confirmationService.confirm({
										message: `There are already ${avail.rollAwayInUse} of ${avail.rollAwayMax} rollaway beds sold for overlapping reservations. No more are available in our warehouse. You can still add this rollaway bed, but it will need to be sourced from an external vendor.`,
										header: 'Inventory Warning',
										icon: 'pi pi-exclamation-triangle',
										acceptLabel: 'Proceed Anyway',
										rejectLabel: 'Cancel',
										accept: () => { this.executeFormAdd(); },
										reject: () => {
											this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Add canceled.', life: 3000 });
										}
									});
									return;
								}
								if (bedType === 'futon' && avail.futonAvailable === 0) {
									this.confirmationService.confirm({
										message: `There are already ${avail.futonInUse} of ${avail.futonMax} futon beds sold for overlapping reservations. No more are available in our warehouse. You can still add this futon, but it will need to be sourced from an external vendor.`,
										header: 'Inventory Warning',
										icon: 'pi pi-exclamation-triangle',
										acceptLabel: 'Proceed Anyway',
										rejectLabel: 'Cancel',
										accept: () => { this.executeFormAdd(); },
										reject: () => {
											this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Add canceled.', life: 3000 });
										}
									});
									return;
								}
							}
							// Inventory still available — proceed directly
							this.executeFormAdd();
						},
						(err: any) => {
							// If availability check fails, log and proceed rather than blocking admin
							console.log('getBedAvailability FAIL: ' + JSON.stringify(err));
							this.executeFormAdd();
						}
					);
				return;
			}

			// Not a bed product or no reservationId — proceed directly
			this.executeFormAdd();

		} catch (error) {
			this.alertService.error(error);
		}
	}

	private executeFormAdd() {
		const payload = { ...this.form1.value, password: this.password };
		console.log('property-add post: ' + JSON.stringify(payload));
		this.formLoading = true;
		this.orderDetailService.add(payload)
			.subscribe(
				(res: any) => {
					console.log('property-add SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					this.orderDetail = res.data.orderDetail;
					this.doAdd.emit(this.orderDetail);
					// formLoading intentionally left true after success to prevent duplicate saves
				},
				(err: any) => {
					// Do NOT reset formLoading on error — a 504 means the backend may
					// have already saved the order detail. Keep button disabled to block re-submit.
					console.log('orderDetail-add FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				});
	}

	private getSelectedBedType(): 'rollaway' | 'futon' | null {
		if (!this.orderProducts) { return null; }
		const selectedOrderProductId = this.form1.value?.orderProductId;
		if (!selectedOrderProductId) { return null; }
		const selectedProduct = this.orderProducts.find(
			(p: any) => p.orderProductId === selectedOrderProductId
		);
		if (!selectedProduct) { return null; }
		const productName: string = (selectedProduct.name || '').toLowerCase();
		if (productName.includes('roll away') || productName.includes('rollaway')) {
			return 'rollaway';
		}
		if (productName.includes('futon')) {
			return 'futon';
		}
		return null;
	}

	formUpdate() {
		console.log('orderDetail: ' + JSON.stringify(this.form1.value));
		try {
			if (this.formLoading) { return; }
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			const payload = { ...this.form1.value, password: this.password };
			this.orderDetailService.update(payload)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderDetail = res.data.orderDetail;
						this.doUpdate.emit(this.orderDetail);
						// formLoading intentionally left true after success to prevent duplicate saves
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may
						// have already saved the update. Keep button disabled to block re-submit.
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderDetailService.delete(this.orderDetail.orderDetailId, this.password)
				.subscribe(
					(res: any) => {
						console.log('orderDetail-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderDetail);
					},
					(err: any) => {
						console.log('orderDetail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderDetailId: [this.orderDetailId],
			orderId: [],
			orderProductId: [],
			reservationId: [],
			bedId: [],
			quantity: ['',Validators.required],
			listPrice: ['',Validators.required],
			listPriceAdjustmentPercent: [],
			listPriceAdjustmentAmount: [],
			description: [],
			privateNotes: [],
			publicNotes: [],
			changeLog: [],
			guestNotes: [],
			name: [],
			salesTaxable: [],
			roomTaxable: [],
			password: [this.password],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderDetail.orderDetailDate = moment(this.orderDetail.orderDetailDate).toDate();
	}
	fetchOrderProducts() {
		if (!this.orderProducts || this.orderProducts === undefined || this.orderProducts.length < 1) {
			try {
				this.orderProductService.findPropertyInvoiceOrderProduct(this.shortTermRentalId)
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.orderProducts = res.data.orderProducts;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.orderProducts);
		}
	}

	
	fetchBeds() {
		if (!this.beds || this.beds === undefined || this.beds.length < 1) {
			try {
				this.bedService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.beds = res.data.beds;
							return this.beds;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.beds);
		}
	}
	
	fetchProperty() {
		if (!this.shortTermRentalId) {
			return;
		}
		try {
			this.propertyService.findById(this.shortTermRentalId)
				.subscribe(
					(res: any) => {
						this.property = res.data.property;
					},
					(err: any) => {
						console.log('fetchProperty FAIL: ' + JSON.stringify(err));
					},
					() => { });
		} catch (error) {
			console.log('fetchProperty error: ' + error);
		}
	}

	validateBedAvailability(): string | null {
		if (!this.property || !this.orderProducts) {
			return null;
		}
		const selectedOrderProductId = this.form1.value?.orderProductId;
		if (!selectedOrderProductId) {
			return null;
		}
		const selectedProduct = this.orderProducts.find(
			(p: any) => p.orderProductId === selectedOrderProductId
		);
		if (!selectedProduct) {
			return null;
		}
		const productName: string = (selectedProduct.name || '').toLowerCase();
		if (productName.includes('roll away') || productName.includes('rollaway')) {
			const count = this.property.rollAwayBedNum;
			if (count === null || count === undefined || count === '' || Number(count) < 1) {
				return 'Error: There are no rollaway beds available at this property.';
			}
		}
		if (productName.includes('futon')) {
			const count = this.property.futonBedNum;
			// Only block if explicitly set to 0 or negative — null/undefined/blank
			// means the property has no configured count, so allow it through.
			if (count !== null && count !== undefined && count !== '' && Number(count) < 1) {
				return 'Error: There are no futon beds available at this property.';
			}
		}
		return null;
	}

	getOrderDetailNameValue(orderDetail: any) {
		if (orderDetail?.name) {
			const orderDetail = this.orderDetails.find((e: any) => e.name == orderDetail.name);
			return orderDetail.value;
		}
		else {
			return '';
		}
	}

	onProductSelect($event: any) {
		if(this.orderProducts){
			let filteredOrderProduct = this.orderProducts.filter(orderProduct =>
			{
				return orderProduct.orderProductId === this.form1.value?.orderProductId;
			});
			if(filteredOrderProduct.length > 0){
				let selectedOrderProduct = filteredOrderProduct[0];
				this.orderDetail.listPrice =  selectedOrderProduct.listPrice;
				this.orderDetail.description = selectedOrderProduct.description;
				this.form1.patchValue(this.orderDetail);
			}
		}
	}
}
